import i18next from "i18next";
import { Link } from "react-router-dom";
import {
  AirlineLogo,
  Button,
  CheckItem,
  CheckList,
  LogosRow,
  Section,
  Title,
} from "./style";

export const WhyUsComponent = () => {
  const { t } = i18next;

  return (
    <Section>
      <Title>{t("why_us_title")}</Title>
      <LogosRow>
        <AirlineLogo src="/images/AK/SZ.png" alt="Somon Air" />
      </LogosRow>
      <CheckList>
        <CheckItem>{t("why_us_item_1")}</CheckItem>
        <CheckItem>{t("why_us_item_2")}</CheckItem>
        <CheckItem>{t("why_us_item_3")}</CheckItem>
        <CheckItem>{t("why_us_item_4")}</CheckItem>
      </CheckList>
      <Button as={Link} to="/contacts">{t("why_us_button")}</Button>
    </Section>
  );
};
